import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";
import { NAV_LINKS } from "@/data/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <div className="flex h-16 md:h-20 items-center justify-between">
          <Logo />
          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                to={link.to}
                className={({ isActive }) =>
                  `font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:text-gold ${
                    isActive ? "text-gold" : "text-white/70"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              data-testid="nav-cta-join"
              to="/contact"
              className="bg-gold text-ink px-5 py-2.5 font-bold uppercase text-xs tracking-[0.15em] clip-frame-sm hover:bg-gold-light transition-colors duration-300"
            >
              Join Now
            </Link>
          </nav>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden glass border-t border-white/10">
          <nav className="px-4 sm:px-8 py-6 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                data-testid={`nav-mobile-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                to={link.to}
                className={({ isActive }) =>
                  `font-display uppercase text-2xl py-2.5 border-b border-white/5 ${
                    isActive ? "text-gold" : "text-white"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              data-testid="nav-mobile-cta-join"
              to="/contact"
              className="mt-4 bg-gold text-ink text-center px-5 py-3.5 font-bold uppercase text-sm tracking-[0.15em]"
            >
              Join Now
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
